import { render } from "./Urlaubsarten.vue?vue&type=template&id=7c5aef36"
import script from "./Urlaubsarten.vue?vue&type=script&lang=js"
export * from "./Urlaubsarten.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__